export const site = {
  name: "Rangel's Painting",
  contactName: 'Micheal',
  phone: '806-801-4211',
  phoneHref: 'tel:8068014211',
  smsHref: 'sms:8068014211',
  area: 'Lubbock & the South Plains',
  logo: 'https://cdn.magicpatterns.com/uploads/pB6RpW2fWyRwgrMzDVyFnc/rangels-painting.png'
}
